import './App.css';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import {useEffect} from "react";
import AOS from "aos";
import 'aos/dist/aos.css';
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ProductPage from "./pages/ProductPage";
import ContactUsPage from "./pages/ContactUsPage";
import Navigation from "./layouts/Navigation";
import Footer from "./layouts/Footer";
import * as emailjs from "@emailjs/browser";

function App() {
    useEffect(() => {
        AOS.init({
            duration: 800,
            once: true,
        });
        emailjs.init({
            publicKey: 'DIWz1lqTfINJJZDhu',
            blockHeadless: true,
            limitRate: {
                id: 'app',
                throttle: 10000, //Allow 1 request per 10s
            },
        });
    }, []);
    return (
        <div className="App no-scrollbar overflow-x-hidden">
            <Router>
                <Navigation/>
                <Routes>
                    <Route path="/" exact element=<HomePage/>/>
                    <Route path="/product" element=<ProductPage/>/>
                    <Route path="/product/:type" element=<ProductPage/>/>
                    <Route path="/product/:type/:id" element=<ProductPage/>/>
                    <Route path="/about" element=<AboutPage/>/>
                    <Route path="/contact" element=<ContactUsPage/>/>
                </Routes>
                <Footer/>
            </Router>
        </div>
    );
}

export default App;
